import PropTypes from "prop-types";
import styled from "styled-components";

const Menu = styled.ul`
    width: 100%;
    list-style: none;
    margin: 0;
    padding: 0;
`;

export default Menu;
